import { Instagram } from "lucide-react";
import ValouseNewsletterSection from "../valouse/ValouseNewsletterSection";

const ConnectionSection = () => {
  return (
    <ValouseNewsletterSection />
  );
};

export default ConnectionSection;
